import { defineMessages } from 'react-intl';

export default defineMessages({
  defaultLabel: {
    id: 'booking.payment.button',
    defaultMessage: 'Pay and confirm',
  },
  pendingLabel: {
    id: 'booking.payment.pending.button',
    defaultMessage: 'Sending request',
  },
});
